import i18n from "i18next";

import { messages } from "./languages";

i18n.init({
	debug: false,
	// El CRM se opera en español, sin tomar el idioma del navegador.
	lng: "es",
	fallbackLng: "es",
	supportedLngs: ["es"],
	defaultNS: ["translations"],
	ns: ["translations"],
	resources: messages,
	interpolation: {
		escapeValue: false,
	},
});

export { i18n };
